<button igxButton="contained" igxRipple="white" title="{{ 'TOOLTIPS.VER_CONTENIDO' | translate}}"
        class="neo-border-inverse" (buttonClick)="verContenido(valor)">
  <igx-icon class="btn-url-contenido__icon"
            [class.btn-url-contenido__icon--available]="activarBoton()"
            [class.btn-url-contenido__icon--unavailable]="!activarBoton()">file_present</igx-icon>
</button>
